import { Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AuthConfigService, GlobalMessageService, GlobalMessageType, RoutingService } from '@spartacus/core';
import { CustomFormValidators } from '@spartacus/storefront';
import { UserRegisterService } from '@spartacus/user/profile/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { Statuses } from 'src/feature-libs/kn-br-cart/quote/root/models/kn-br-quote.model';
import { KnBrUserSignUp } from 'src/app/models/kn-br-user-signup.model';
import { KnBrCommonService } from 'src/app/services/kn-br-common.service';
import { environment } from 'src/environments/environment';
declare function ClickwrapSubmitData(firstName: string, lastName: string, email: string, GroupKey);
declare function clickwrapData(SiteAccessId, GroupKey);
@Component({
  selector: 'knbr-register',
  templateUrl: './kn-br-user-register.component.html',
})
export class KnBrUserRegisterComponent implements OnInit, OnDestroy {
  jobFunctionList$: Observable<Statuses[]> = this.knBrCommonService.loadJobFunctionList$();
  isLoading$ = new BehaviorSubject(false);
  private subscription = new Subscription();
  recaptchaToken: string | undefined;
  sloantermsofuse = environment.sloantermsofuse;
  sloanprivacypolicy = environment.sloanprivacypolicy;
  SiteAccessId = environment.siteAccessId;
  GroupKey = environment.groupKey;
  emailSmall: string;
  registerForm: UntypedFormGroup = this.fb.group(
    {
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', [Validators.required, CustomFormValidators.emailValidator]],
      emailconf: ['', Validators.required],
      jobFunction: [''],
      contactNumber: [''],
      unit: ['', Validators.required],
      token: ['', Validators.required],
      acceptanceCheckbox: [false],
    },
    {
      validators: CustomFormValidators.emailsMustMatch('email', 'emailconf'),
    }
  );

  constructor(
    protected userRegisterService: UserRegisterService,
    protected globalMessageService: GlobalMessageService,
    protected fb: UntypedFormBuilder,
    protected router: RoutingService,
    protected authConfigService: AuthConfigService,
    protected knBrCommonService: KnBrCommonService,
    private renderer: Renderer2
  ) {
    this.recaptchaToken = undefined;
    clickwrapData(this.SiteAccessId, this.GroupKey);
  }

  ngOnInit() {
    this.renderer.addClass(document.body, 'recaptcha');
    this.knBrCommonService.getJobFunctionList();
  }

  submitForm(): void {
    if (this.registerForm.valid) {
      this.registerUser();
    } else {
      this.registerForm.markAllAsTouched();
    }
  }

  registerUser(): void {
    this.isLoading$.next(true);
    this.userRegisterService
      .register(this.collectDataFromRegisterForm(this.registerForm.value))
      .subscribe((res: any) => {
        if (res?.userExists) {
          this.isLoading$.next(false);
          this.globalMessageService.add(res?.response, GlobalMessageType.MSG_TYPE_ERROR);
        } else {
          this.globalMessageService.add(res?.response, GlobalMessageType.MSG_TYPE_CONFIRMATION);
          this.emailSmall = this.registerForm.value.email.toLowerCase()
          ClickwrapSubmitData(this.registerForm.value.firstName, this.registerForm.value.lastName, this.emailSmall, this.GroupKey);

          this.onRegisterUserSuccess();
        }
      });
  }

  collectDataFromRegisterForm(formData: any): KnBrUserSignUp {
    const { firstName, lastName, email, unit, jobFunction, contactNumber, token } = formData;
    return {
      firstName,
      lastName,
      uid: email.toLowerCase(),
      unit,
      jobFunction,
      contactNumber,
      token,
    };
  }

  private onRegisterUserSuccess(): void {
    this.router.go('login');
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.renderer.removeClass(document.body, 'recaptcha')
  }
}
